import styles from 'shared/Loading/Loading.module.scss'

export default function Loading() {
  return <span className={styles.loading} />
}
